// src/hooks/useUpdateUserProfile.ts
import { useState } from 'react';
import { Contact } from '../interfaces';
import config from '../config';
import { useSession } from '../contexts/SessionContext';
import { useTranslation } from 'react-i18next';

const useAddContactToCustomer = () => {
  const [error, setError] = useState<string | null>(null);
  const { sessionState } = useSession();
  const { t } = useTranslation();

  const addContactToCustomer = async (deviceCrmContactData: Contact) => {
    const token = sessionState.account?.token;
    if (!token) {
      setError('Login or token is missing');
      return false;
    }

    try {
      const response = await fetch(`${config.centralApiBaseUrl}/Contact`, {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(deviceCrmContactData),
      });

      if (!response.ok) {
        if (response.status === 404) {
          throw new Error(t("devices.crm.contact.errorMessageToAddContact"))
        }
        throw new Error(t('devices.crm.contact.failedAddContact'));
      }

      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      return false;
    }
  };

  return { addContactToCustomer, error };
};

export default useAddContactToCustomer;
